import { invokeHttp } from './api'

export const create = (comment) =>
  invokeHttp('/admin/patient/comment/create', comment)

export const list = (patientId) =>
  invokeHttp('/admin/patient/comment/list', { patientId })

export const update = (comment) =>
  invokeHttp('/admin/patient/comment/update', comment)

export const remove = (id) =>
  invokeHttp('/admin/patient/comment/delete', { id })

export const createimage = (patientId, image) =>
  invokeHttp(`/admin/patient/comment/createimage?patientId=${patientId}`, image)
